export default {
  nav: {
    app:'店铺助手',
    logout: '退出登录',
    telService: '电话客服', onlineService: '在线客服',
    help:'帮助',
    privacy:'隐私',
    provision:'条款',
  },
  label: {
    loginWelcome:'欢迎来到优衣库Tapestry下单系统',
    login:'登录',
    account:'账号',
    pass:'密码',
    inputAccount:'请输入店号',
    inputPass:'请输入密码',
    inputLenAccount:'长度在1到20个字符',
    inputLenPass:'长度在3到20个字符',
    forgetPass:'忘记密码？',
    contactService:'联系客服',
    copyright:'释空提供技术支持',
    shopMap:'店铺地图',
    shopname:'当前店铺',
    clickHelp:'点击点位进行选图',
    floor:'楼层',
    pointCurrent:'当前正在选图',
    pointChoosed:'店铺已完成选图',
    pointNone:'店铺决定本次不投入',
    pointNotyet:'待店铺选图',
    pointReview:'选图结果预览',
    pointSave:'完成并保存',
    pointList:'当前下单表',
    orderHistory:'历史订单',
    del:'删除',
    timeLeft:'距离下单时间截止还有',
    waitOrder:'店铺下单暂未开启，敬请期待',
    day:'天',
    hour:'小时',
    min:'分',
    second:'秒',
    oldimg:'原画面',
    newimg:'新画面',
    chooseTips:'请选择所需安装的画面',
    selectFor:'点位需要图片数：',
    selectPlaceholder:'图片分组编号/图片编号',
    selected:'已选',
    selectBtn:'确认选择',
    btnBack:'返回选图页面',
    btnDownPDF:'下载PDF',
    shopNone:'店铺未选图，本次不做生产和投入',
    btnDownPointList:'下载点位清单',
    btnViewPointReport:'查看选图结果'
  },
  table:{
    kind:'楼层',
    pointid:'点位',
    location:'位置',
    material:'材质',
    size:'尺寸(幅数)',
    oldimg:'安装前',
    count:'幅数',
    newimg:'安装后',
    action:'操作',
    orderNo:'订单编号',
    orderState:'订单状态',
    orderCreatedAt:'下单时间',
    orderCreatedBy:'下单人',
    deadline:'截止时间',
    date:'时间',
    ordernum:'批次号'
  },
  msg:{
    confirmLogout:'确认退出么？',
    confirmDelImg:'确认删除图片么？',
    confirmDownPoint:'确认下载点位明细么？',
    plsChooseImg:"请选择图片",
    plsChooseImgCount:"请选择点位需要的图片数",
    chooseSuccess:'选图成功'
  }
}